
import moment from "moment";
import { Options, Vue } from "vue-class-component";
import Toaster from "../helpers/Toaster";
import VoucherService from "../service/VoucherService.js";
import ProfilerService from "../service/ProfilerService.js";
import UserService from "../service/UserService.js";
import AutoComplete from "primevue/autocomplete";

@Options({
    props: {
        searchDetail: Object,
    },
    components: { AutoComplete },
    watch: {
        searchDetail(obj) {
            this.openDialog();
            this.dialogTitle = obj.dialogTitle;
            this.productDialog = obj.status;
            if (obj.scenario == "PayLater") {
                this.item.filterName = obj.selectedDateFilter;
            }
            this.supplierFilter = obj.supplierFilter;
            this.item.supplierID = obj.selectedSupplierID;
        },
    },
    emits: ["updateFilterStatus"],
})
export default class SearchFilter extends Vue {
    private toast;
    private productDialog = false;
    private dialogTitle = "";
    private voucherService;
    private profilerList = [];
    private userList = [];
    private profilerService;
    private userService;
    private selectedDateFilter = { key: "This Month", value: "this_month" };
    private supplierFilter = false;
    private supplierList = [];

    private item = {
        id: 0,
        loading: "No",
        filterName: this.selectedDateFilter,
        date1: "",
        date2: "",
        storeID: { id: 0 },
        customerName: "All",
        UserName: "All",
        customerID: 0,
        userID: 0,
        supplierID: 0,
    };

    private storeList;
    private filterList;

    //DEFAULT METHOD OF TYPE SCRIPT
    //CALLING WHENEVER COMPONENT LOADS
    created() {
        this.toast = new Toaster();
        this.voucherService = new VoucherService();
        this.profilerService = new ProfilerService();
        this.userService = new UserService();
    }

    mounted() {
        this.getTheStoreFilterList();
    }

    //OPEN DIALOG TO ADD NEW ITEM
    openDialog() {
        this.productDialog = true;
    }

    closeDialog() {
        this.$emit("updateFilterStatus", {});
        this.productDialog = false;
    }

    searchRecords() {
        this.productDialog = false;
        this.item.loading = "Yes";
        if (this.item.date1 != "" && this.item.date2 != "") {
            this.item.date1 = moment(this.item.date1).format("YYYY-MM-DD");
            this.item.date2 = moment(this.item.date2).format("YYYY-MM-DD");
        }

        this.$emit("updateFilterStatus", this.item);
        //console.log("passed item ", this.item);
    }

    getTheStoreFilterList() {
        this.voucherService.getFilterList().then((res) => {
            this.storeList = res.stores;
            this.filterList = res.datesList;
            this.userList = res.userList;
            this.supplierList = res.suppliers;
        });
    }

    clearDates() {
        this.item.date1 = "";
        this.item.date2 = "";
    }

    clearFilterName() {
        this.item.filterName = { key: "None", value: "None" };
    }

    searchProfiler(event) {
        setTimeout(() => {
            this.profilerService
                .searchProfiler(event.query.trim())
                .then((data) => {
                    this.profilerList = data.records;
                    //console.log("profiler list ", this.profilerList);
                });
        }, 200);
    }
    searchUser(event) {
        setTimeout(() => {
            this.userService.searchUser(event.query.trim()).then((data) => {
                this.userList = data.records;
            });
        }, 200);
    }
}
